export default __webpack_public_path__ + "7f8b6363e90575e016549511e5a74ef4.ttf";